<template>
	<div class="float">
		<div class="mark" @click="hideSpeaker"></div>
		<div class="content">
			<div class="title">近距离与专家交谈</div>
			<div class="close" @click="hideSpeaker"></div>
			<div class="con">
				<div class="tip">填写以下信息，即可与专家预约时间，参加专家的线上交谈会，与专家近距离的沟通</div>
				<div class="form">
					<div class="clear item" data-name="company">
						<div class="left tit"><div class="middle"><i>*</i><span>公司名称</span></div></div>
						<div class="left input">
							<input type="text" class="left in" :class="[error.company ? 'error' : '']" @blur="validate('company')" placeholder="请输入公司名称" v-model="form.company" >
							<div class="validate">{{error.company}}</div>
						</div>
					</div>
					<div class="clear item" data-name="username">
						<div class="left tit"><div class="middle"><i>*</i><span>姓名</span></div></div>
						<div class="left input">
							<input type="text" class="left in" :class="[error.username ? 'error' : '']" @blur="validate('username')" placeholder="请输入姓名" v-model="form.username" >
							<div class="validate">{{error.username}}</div>
						</div>
					</div>
					<div class="clear item" data-name="phone">
						<div class="left tit"><div class="middle"><i>*</i><span>手机</span></div></div>
						<div class="left input">
							<input type="text" class="left in" :class="[error.phone ? 'error' : '']" @blur="validate('phone')" placeholder="请输入手机" v-model="form.phone" >
							<div class="validate">{{error.phone}}</div>
						</div>
					</div>
					<div class="clear item" data-name="email">
						<div class="left tit"><div class="middle"><i>*</i><span>邮箱</span></div></div>
						<div class="left input">
							<input type="text" class="left in" :class="[error.email ? 'error' : '']" @blur="validate('email')" placeholder="请输入邮箱" v-model="form.email" >
							<div class="validate">{{error.email}}</div>
						</div>
					</div>
					<div class="clear item" data-name="message">
						<div class="left tit"><div class="middle"><i>*</i><span>预约描述</span></div></div>
						<div class="left input">
							<textarea type="text" class="left in textarea" :class="[error.message ? 'error' : '']" @blur="validate('message')" placeholder="关于您的疑惑或交流时间，您可以简单描述一下" v-model="form.message" ></textarea>
							<div class="validate">{{error.message}}</div>
						</div>
					</div>
				</div>
				<div class="submit">
					<div class="btn" @click="submit">提交</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {Toast} from "vant";

export default {
	name: 'speaker-message',
	data() {
		return {
			form:{
				company:"",
				username:'',
				phone:"",
				email:"",
				message:"",
			},
			error:{},
		}
	},
	props:{
		speaker:{
			type:Object,
			default:{}
		}
	},
	components:{

	},
	computed:{
		user(){
			return this.$store.state.user_info;
		}
	},
	methods: {
		validate(field,name = ""){
			var message = "";
			switch (field) {
				case 'company':
					if(!this.form.company){
						message = "请输入公司名称";
					}else{
						message = "";
					}
					break;
				case 'username':
					if(!this.form.username){
						message = "请输入姓名";
					}else{
						message = "";
					}
					break;
				case 'phone':
					if(!this.form.phone){
						message = "请输入手机号";
					}else if(!this.tool.type.checkStr(this.form.phone,'phone') ){
						message = "请输入正确的手机号";
					}else{
						message = "";
					}
					break;
				case 'email':
					if(!this.form.email){
						message = "请输入邮箱";
					}else if(!this.tool.type.checkStr(this.form.email,'email')){
						message = "请输入正确的邮箱";
					}else{
						message = "";
					}
					break;
				case 'message':
					if(!this.form.message){
						message = "请输入预约描述";
					}else{
						message = "";
					}
					break;
				default:
					break;
			}
			this.setError(name ? name : field,message);
			return message ? false : true;
		},
		validateAll(){
			var company = this.validate('company');
			var username = this.validate('username');
			var email = this.validate('email');
			var phone = this.validate("phone");
			var message = this.validate('message');

			if(!company || !username || !email || !phone || !message ){
				this.$nextTick(()=>{
					this.scrollError();
				})
				return false;
			}else{
				return true;
			}
		},
		setError(name,message =""){
			this.error[name] = message;
			this.$forceUpdate();
		},
		submit(){
			var res = this.validateAll();
			if(!res){return false;}
			var data = this.form;
			data.speaker_id = this.speaker.id;

			gio('track', 'DTF2021_talkSubmit', {
				//'userName':data.username,
				'phoneNumber':this.util.encryptPhone(data.phone),
				// 'company' : data.company,
				// 'email' :data.email,
			});

			this.http.request({
				api:"speaker/message",
				data:data,
				loading:true,
				success:(res)=>{
					Toast.success('提交成功');
					this.hideSpeaker();
				}
			})
		},
		hideSpeaker(){
			this.$emit('hideSpeaker');
		},
		autoComplete(){
			if(this.user && this.user.id){
				var user = JSON.parse(JSON.stringify(this.user));
				this.form.username = user.username;
				this.form.company = user.company;
				this.form.phone = user.phone;
				this.form.email = user.email;
			}
		}
	},
	mounted() {
		this.autoComplete();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.float{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 120;
	.mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,0.7);}
	.content{position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);width: 600px; border-radius: 10px;background: #fff;overflow: hidden;
		.title{height:70px;text-align: center;line-height: 70px;font-size: 30px;color:#fff;background: url("~@/assets/image/1.jpg") no-repeat center center;background-size: cover;}
		.close{position: absolute;top:0;right:0;width: 70px;height:70px;background: url("~@/assets/image/54.png") no-repeat center center;background-size: 19px;cursor: pointer;}
		.con{padding-bottom: 30px;
			.tip{margin-top: 20px;font-size: 14px;color:#444444;line-height: 24px;text-align: center;}
			.form{width: 520px;margin: 20px auto 0;
				.item{
					.tit{ padding-right: 12px;font-size: 16px;line-height: 46px;
						.middle{height:46px; text-align: right;
							i{color: #ff0000;margin-right: 2px;display: inline-block;}
							span{display: inline-block;width: 70px;text-align: justify;text-align-last: justify;}
						}
					}
					.input{width: 410px;
						.in{display: block; width: 380px;height:46px;padding: 0 15px;font-size: 14px; background:#FCFCFC; border-radius: 5px;border: 1px solid #EDEBEB;}
						.textarea{height:100px;padding: 15px;}
						.in.error{border-color: red;}
					}
					.input.error{border: 1px solid red;box-sizing: border-box;border-radius: 5px;}
					.validate{clear: both; height:26px;line-height: 26px;font-size:14px;color:red;}
				}
			}
			.submit{
				.btn{width: 300px;height:40px;line-height: 40px;font-size: 16px;color:#fff;background: #376f84;text-align: center;margin: 0 auto;border-radius: 5px;cursor: pointer;}
			}
		}
	}
}
@media screen and (max-height: 700px) {
	.float{
		.content{
			.con{max-height: 400px;overflow: hidden;overflow-y: auto;}
		}
	}
}
</style>
